export enum StateTypes {
    off,
    on,
    flashing
}